const moduleMap = {
	"./QuoteApp": () => {
		return Promise.all([__webpack_require__.e(188), __webpack_require__.e(246), __webpack_require__.e(692), __webpack_require__.e(493), __webpack_require__.e(209), __webpack_require__.e(644), __webpack_require__.e(524), __webpack_require__.e(123), __webpack_require__.e(738), __webpack_require__.e(472), __webpack_require__.e(154), __webpack_require__.e(265), __webpack_require__.e(331), __webpack_require__.e(176), __webpack_require__.e(379), __webpack_require__.e(680), __webpack_require__.e(224), __webpack_require__.e(758)]).then(() => (() => ((__webpack_require__(96535)))));
	},
	"./prefetch": () => {
		return Promise.all([__webpack_require__.e(188), __webpack_require__.e(493), __webpack_require__.e(209), __webpack_require__.e(644), __webpack_require__.e(524), __webpack_require__.e(123), __webpack_require__.e(738), __webpack_require__.e(154), __webpack_require__.e(265), __webpack_require__.e(331), __webpack_require__.e(379), __webpack_require__.e(224)]).then(() => (() => ((__webpack_require__(56080)))));
	}
};
const get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
const init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	const name = "default"
	const oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});